import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing-cta')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-112">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-113" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-114">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto" data-id="element-115">
          <div className="text-center lg:text-left" data-id="element-116">
            <FadeIn delay={0.1} data-id="element-117">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-card border border-card-border mb-6" data-id="element-118">
                <span className="w-2 h-2 rounded-full bg-primary animate-pulse" data-id="element-119" />
                <span className="text-sm font-medium text-gray-300 uppercase tracking-wider" data-id="element-120">
                  Para Profesionales del Fitness
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-121">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6" data-id="element-122">
                Cómo Justificar Cada Ejercicio con{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-123">
                  Criterio Profesional Real
                </span>{' '}
                en Segundos
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-124">
              <h2 className="text-xl md:text-2xl text-gray-400 mb-10 font-medium max-w-2xl mx-auto lg:mx-0" data-id="element-125">
                Dejá de improvisar y trabajá con una base técnica sólida y
                segura.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-126">
              <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-127">
                <Button onClick={scrollToPricing} className="w-full sm:w-auto md:px-12 md:py-5 md:text-2xl" data-id="element-128">
                  Quiero mi pack ahora
                </Button>
                <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-129">
                  <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-130" />
                  <span data-id="element-131">Compra 100% segura, acceso inmediato.</span>
                </div>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.5} direction="left" className="relative" data-id="element-132">
            <motion.div animate={{
            y: [0, -15, 0]
          }} transition={{
            repeat: Infinity,
            duration: 6,
            ease: 'easeInOut'
          }} className="relative z-10" data-id="element-133">
              <img src="https://cdn.magicpatterns.com/uploads/wyqfb8p7SeD2jNHCL2SBD3/mock_up_principal.png" alt="Pack Bases del Entrenamiento de Fuerza" className="w-full max-w-[600px] mx-auto drop-shadow-2xl" data-id="element-134" />
            </motion.div>
            {/* Image backdrop glow */}
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent blur-3xl -z-10 rounded-full" data-id="element-135" />
          </FadeIn>
        </div>
      </div>
    </section>;
}